export default import.meta.ROLLDOWN_FILE_URL_zc28wjX9jUVW7jV_qPTNNw